import { useTranslation } from 'react-i18next';
import { Browser } from '@capacitor/browser';
import { Box, Link, Stack, Typography } from '@mui/material';

import { DEUTSCHLANDTARIFVERBUND_URL } from '@mopla/constants';
import { MplButton, MplModal } from '@mopla/ui';

interface IDTicketHelpModalProps {
	open: boolean;
	onClose: () => void;
}

export const DTicketHelpModal = ({ open, onClose }: IDTicketHelpModalProps) => {
	const { t } = useTranslation('userDTicket');

	const featuresObj = t('help_section.modal.features', {
		returnObjects: true,
	}) as Record<string, string>;
	const features = Object.values(featuresObj);

	const modalContent = (
		<Stack spacing={2} sx={{ textAlign: 'left', mt: '-8px' }}>
			<Typography variant="b2" color="primary.main">
				{t('help_section.modal.intro')}
			</Typography>

			<Box>
				<Typography variant="b2" color="primary.main">
					{t('help_section.modal.features_title')}
				</Typography>
				<Box component="ul" sx={{ m: 0, pl: 2.5 }}>
					{features.map((feature, index) => (
						<Typography
							key={index}
							component="li"
							variant="b2"
							color="primary.main"
						>
							{feature}
						</Typography>
					))}
				</Box>
			</Box>

			<Typography variant="b2" color="primary.main">
				{t('help_section.modal.validity')}
			</Typography>

			<Typography variant="b2" color="primary.main">
				{t('help_section.modal.report_prefix')}
				<Link
					component="button"
					underline="always"
					onClick={() => Browser.open({ url: DEUTSCHLANDTARIFVERBUND_URL })}
					sx={{ cursor: 'pointer', verticalAlign: 'baseline' }}
				>
					{t('help_section.modal.report_link')}
				</Link>
				{t('help_section.modal.report_suffix')}
			</Typography>

			<Typography variant="b2" color="primary.main">
				{t('help_section.modal.refund')}
			</Typography>
		</Stack>
	);

	return (
		<MplModal
			open={open}
			onClose={onClose}
			testId="UserDTicket-DTicketHelpModal"
			title={t('help_section.modal.title')}
			textAlign="left"
			content={modalContent}
			buttons={
				<MplButton
					variant="contained"
					color="primary"
					fullWidth
					onClick={onClose}
					testId="dticket-helpModal-close-button"
				>
					{t('help_section.modal.button')}
				</MplButton>
			}
		/>
	);
};
